import React, { forwardRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import type * as CSS from 'csstype';
import './dialog.css';

export interface ISmallDialogProps {
	onClose: (event: UIEvent) => void;
	style?: CSS.Properties;
	overlayStyle?: CSS.Properties;
	children: React.ReactNode;
}

const SmallDialog = forwardRef(
	(props: ISmallDialogProps, ref: React.Ref<HTMLDivElement>) => {
		useEffect(() => {
			// Set overflow hidden on the body element to avoid the background of the dialog scrolling
			document.body.style.overflow = 'hidden';

			return () => {
				// Reset overflow to its default value
				document.body.style.overflow = 'auto';
			};
		}, []);

		return createPortal(
			<div
				ref={ref}
				style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100vw',
					height: '100vh',
					backgroundColor: 'rgba(0, 0, 0, 0.54)',
					zIndex: 1250,
					display: 'flex',
					justifyContent: 'center',
					...props.overlayStyle,
				}}
				onClick={(event: any) => {
					props.onClose?.(event);
				}}
			>
				<div
					onClick={(e) => {
						// We want to stop the propagation of the click event so that it doesn't trigger the click event on the parent element
						// The parent element is the screen overlay, when clicked, we want to close the dialog.
						e.stopPropagation();
					}}
					className='dialog__body__small'
					style={props.style}
				>
					{props.children}
				</div>
			</div>,
			document.body
		);
	}
);

export default SmallDialog;
